import serchApi from '../../api/serchAttractions';
import editApi from '../../api/editRide';
import globalRidesApi from '../../api/globalRides';
import { router } from '../../main';

const state = {
  serchAttractios: {},
  lat: +48.18,
  lng: +16.30,
  plannedDate: null,
  serchDayIndex: null,
  sorce: 'internal',
  searchAttractionsFilters: {},
  // rideId: null
};

const getters = {
  serchAttractios: state => state.serchAttractios,
  lat: state => state.lat,
  lng: state => state.lng,
  plannedDate: state => state.plannedDate,
  serchDayIndex: state => state.serchDayIndex,
  serchAttractiosSorce: state => state.sorce,
  searchAttractionsFilters: state => state.searchAttractionsFilters,
  // rideId: state => state.rideId
};

const actions = {
  async fetchSerchAttractionsFromRideMangerAcount({ state, rootState, commit, dispatch }, payload = {}) {
    const requestFilters = {
      ...state.searchAttractionsFilters,
      ...(payload.filters || {})
    };
    commit('setSearchAttractionsFilters', requestFilters);
    const rideId = rootState.ride.rideId;
    const lat = state.lat; 
    const lng = state.lng;
    const { apptoken } = rootState.appauth;
    commit('setSerchAttractions', {});
    commit('setSerchSorce', 'internal');
    dispatch('showModal', "loadingIcon");
    try {
      const response = await serchApi.fetchSerchAttractionsFromRideMangerAcount(apptoken, rideId, lat, lng, requestFilters);
      commit('setSerchAttractions', response.data);
      await dispatch('updateMarkerByScrollerLocation');
    }
    finally {
      dispatch('showModal', "");
    }
  },
  async fetchSerchAttractionsByRide({ state, rootState, commit, dispatch }, sorce='internal') {
    const rideId = rootState.ride.rideId;
    // we should add the option to serch attraction when the day is empty from
    // attraction ( we should use the globak ride location or the last point that have activity)
    const lat = state.lat; 
    const lng = state.lng;
    const { apptoken } = rootState.appauth;
    var response;
    if( sorce == 'internal' ){
      commit('setSerchAttractions', {});
      response = await serchApi.fetchSerchAttractionsByRide(apptoken, rideId, lat, lng);
      commit('setSerchSorce', 'internal');
    }
    else if( ( sorce == 'google' ) || ( sorce == 'googleRestorant' ) ){
      var serchType;
      if( sorce == 'google'){
        serchType = 'googleAttractions';
      }
      else{
        serchType = sorce;
      }
      commit('setSerchAttractions', {});
      response = await serchApi.fetchSerchActivityByRideFromGoogle(apptoken, rideId, lat, lng, serchType);
      commit('setSerchSorce', 'google');
    }
    // else if( sorce == 'googleRestorant' ){
    //   response = await serchApi.fetchSerchRestornatsByRideFromGoogle(apptoken, rideId, lat, lng);
    //   // the input sorece is google and not googleRestorant
    //   commit('setSerchSorce', 'google');
    // }
    commit('setSerchAttractions', response.data);
    await dispatch('updateMarkerByScrollerLocation');
    //router.push('/serch_attractions');
  },
  async uplowedGoogleAtractionIfEmpty({ getters, dispatch },){
    const attractiosSorce = getters.serchAttractiosSorce;
    const serchAttractios = getters.serchAttractios;
    if( (attractiosSorce == 'internal') && ( serchAttractios.length == 0 ) ){
      await dispatch('fetchSerchAttractionsByRide', 'google' );
    }
  },
  updateSearchAttractionsFilters({ commit }, filters = {}) {
    commit('setSearchAttractionsFilters', filters);
  },
  resetSearchAttractionsFilters({ commit }) {
    commit('replaceSearchAttractionsFilters', {
      rideAttractionPresence: 'exclude_existing'
    });
  },
  
  // we should move this method to _____!
  async addAttractionToRide( {dispatch, getters, state, rootState }, attractionInfo ){
    const { apptoken } = rootState.appauth;
    const authorId = getters.allRide.ride.authorId;
    const userIsTheRideHoner = await dispatch( 'equalToUserId', authorId );
    if( apptoken ){
      if( userIsTheRideHoner ){
        const rideId = rootState.ride.rideId;
        const plannedDate = state.plannedDate
        const shouldCopyTheAttraction = attractionInfo.shouldCopyTheAttraction ?? false;
        // print( attractionInfo['attractionId'] )
        // print( attractionInfo['sorce'] )
        dispatch( 'showModal', "loadingIcon" );
        if ( attractionInfo['sorce'] == "internal" ){
          await editApi.addAttractionToRide(  apptoken,
                                              rideId,
                                              attractionInfo['attractionId'],
                                              plannedDate,
                                              shouldCopyTheAttraction
                                             );
          }
        else if ( attractionInfo['sorce'] == "google" ){
          await editApi.addgooglePlaceToRide( apptoken,
                                              rideId,
                                              attractionInfo['attractionId'],
                                              plannedDate );
        }
        dispatch( 'showModal', "" );
        router.push('/single_ride_with_map/' + rideId );
      }
      else{
        dispatch( 'showModal', "pleaseAddTheRideToYourList" );
      }
    }
    else{
      dispatch( 'showModal', "pleaseLogInInOrderToEditRide" );
    }
  },

  async updateAllSerchPonitsOnMap({dispatch}, filters){
    const sertchPoints = await globalRidesApi.fetchallSerchpoints(filters);
    var lat = 0;
    var lng = 0;
    const localSerchPoints = sertchPoints.data.serch_points.sertchPoint;
    for( var i=0; i < localSerchPoints.length; i++ ){
      console.log("internal aading point")
      lat = localSerchPoints[i].lat;
      lng = localSerchPoints[i].lng;
      dispatch( 'addMarkerByLatAndLngToGlobalMap', { latPoint: lat, lngPoint: lng, name:localSerchPoints[i].count.toString() });
    }
    return sertchPoints
  },
  
};

const mutations = {
  setSerchAttractions: (state, serchAttractios) => {
    state.serchAttractios = serchAttractios;
  },
  setSerchLat: (state, lat) => {
    state.lat = lat;
  },
  setSerchLng: (state, lng) => {
    state.lng = lng;
  },
  setSerchPlannedDate: (state, plannedDate) => {
    state.plannedDate = plannedDate;
  },
  setSerchDayIndex: (state, serchDayIndex) => {
    state.serchDayIndex = serchDayIndex;
  },
  setSerchSorce: ( state, sorce) =>{
    state.sorce = sorce;
  },
  setSearchAttractionsFilters: (state, filters = {}) => {
    state.searchAttractionsFilters = {
      ...state.searchAttractionsFilters,
      ...filters
    };
  },
  replaceSearchAttractionsFilters: (state, filters = {}) => {
    state.searchAttractionsFilters = { ...filters };
  }
  
};

export default {
  state,
  getters,
  actions,
  mutations
};
